__turbopack_context__.v({
  "className": "jetbrains_mono_bb9c8c57-module__n3apLq__className",
});
